import { Guid } from "@syncfusion/ej2/pdf-export";

export class GetviewBO {
    orderColumn: string = "ClientName";
    orderType: string= "asc";
    pageitem: number = 10;
    currentpageno: number = 1;
    agencyID: string="00000000-0000-0000-0000-000000000000";
    field: string = "ClientName";
    value: string = "";
    matchCase: boolean = false;
    operator: string = "startswith";
    type:string="string";

}
export class ColumnChangeBO {
    id: string="00000000-0000-0000-0000-000000000000";
    userid: string="00000000-0000-0000-0000-000000000000";
    agencyId: string="00000000-0000-0000-0000-000000000000";
    column: string;
}

export class EDI271ClientBO {
    clientIdQualifier: string;
    clientID: string;
    clientName: string;
    addressLine1: string;
    addressLine2: string;
    city: string;
    state: string;
    zipCode: string;
    dOB: string;
    gender: string;
    lastEligibilityCheck: string | null;
    clientPkId: Guid | null;
    medicaid: string;
}

export class generate270
{
    groupId:string="00000000-0000-0000-0000-000000000000";
    payorId:string="00000000-0000-0000-0000-000000000000";
    companyId:string="00000000-0000-0000-0000-000000000000";
    clearingHouseId:string="00000000-0000-0000-0000-000000000000";
}

export class reutrn270 {
    fileName: string;
    payerDetail: PayerDetail;
    companyDetail: CompanyDetail;
    clinetDetail: ClinetDetail[];
    clearingHouseDetail: clearinghouseBO;
    eligibility270Id: Guid;
    created_Date: string;
    filePath:string;
}

export class clearinghouseBO {
    receiverId: string;
    clearingHouseName: string;
    receiver_Qualifier: string;
    clearingHouseId: string;
    senderId: string;
    sender_Qualifier: string;
}

export class PayerDetail {
    payer_Name: string;
    payer_Address_1: string;
    payer_Address_2: string;
    payer_City: string;
    payer_State: string;
    payer_Zip: string;
    payer_FEIN: string;
    billing_payor_ID: string;
    renderingProviderID: boolean;
    providerNo: string;
    _837I_Ins_ID: string;
    companyFEIN: string;
    claim_Filling_Ind: string;
    aTYPICAL: boolean;
    payorId: Guid | null;
}

export class ClinetDetail {
    clinet_FirstName: string;
    clinet_LastName: string;
    cLient_MiddleName: string;
    clinet_Address_1: string;
    clinet_Address_2: string;
    clinet_City: string;
    clinet_State: string;
    clinet_Zip: string;
    service_AgreementNo: string;
    client_Insurance: string;
    client_DOB: string;
    client_Gender: string;
}
export class CompanyDetail {
    senderId: string;
    sender_Qualifier: string;
    company_Name: string;
    response_Contact_Name_Or_Organization_Name: string;
    company_PhoneNumber: string;
    company_ProviderNo: string;
    company_Address_1: string;
    company_Address_2: string;
    company_City: string;
    company_State: string;
    company_Zip: string;
}